import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { io, Socket } from 'socket.io-client';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ChatApiService {
  private baseUrl = environment.apiUrl;
  public socket: Socket; // <-- Make this public if you want, but best to use methods below

  // constructor(private http: HttpClient) {
  //   this.socket = io('http://localhost:5000'); // or your backend URL
  // }

   constructor(private http: HttpClient) {
    this.socket = io('https://chat-back-0bvk.onrender.com'); // or your backend URL
  }

  // --- Chat APIs ---
  sendChatMessage(senderId: string, receiverId: string, content: string) {
  this.socket.emit('sendChatMessage', { senderId, receiverId, content });
}

getChatHistory(userId: string, token: string, limit: number = 30, skip: number = 0) {
  return this.http.get(`${this.baseUrl}/chat/history/${userId}?limit=${limit}&skip=${skip}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
}

  onMessage(): Observable<any> {
    return new Observable(observer => {
      this.socket.on('chatMessage', (msg) => observer.next(msg));
    });
  }

  registerUser(userId: string) {
    this.socket.emit('register', userId);
  }

  getUserById(userId: string, token: string) {
    return this.http.get(`${this.baseUrl}/users/${userId}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
  }

  markMessagesRead(friendId: string, token: string) {
    return this.http.post(`${this.baseUrl}/chat/mark-read`, { friendId }, {
      headers: { Authorization: `Bearer ${token}` }
    });
  }

  getConversations(token: string) {
    return this.http.get(`${this.baseUrl}/chat/conversations`, {
      headers: { Authorization: `Bearer ${token}` }
    });
  }

  deleteConversations(userIds: string[], token: string) {
    return this.http.post(`${this.baseUrl}/chat/delete-conversations`, { userIds }, {
      headers: { Authorization: `Bearer ${token}` }
    });
  }

  // --- Call Signaling Methods ---
  callUser(fromUserId: string, toUserId: string, callType: 'audio' | 'video') {
    this.socket.emit('callUser', { fromUserId, toUserId, callType });
  }

  acceptCall(fromUserId: string, toUserId: string) {
    this.socket.emit('callAccepted', { fromUserId, toUserId });
  }

  rejectCall(fromUserId: string, toUserId: string) {
    this.socket.emit('callRejected', { fromUserId, toUserId });
  }

onIncomingCall(callback: (data: any) => void) {
  this.socket.off('incomingCall');
  this.socket.on('incomingCall', callback);
}

onCallBusy(callback: () => void) {
  this.socket.off('callBusy');
  this.socket.on('callBusy', callback);
}

onCallRejected(callback: (data: any) => void) {
  this.socket.off('callRejected');
  this.socket.on('callRejected', callback);
}

onCallEnded(callback: () => void) {
  this.socket.off('callEnded');
  this.socket.on('callEnded', callback);
}

  // --- WebRTC Signaling Methods ---
  sendWebrtcOffer(toUserId: string, fromUserId: string, offer: any) {
    this.socket.emit('webrtc-offer', { toUserId, fromUserId, offer });
  }

  sendWebrtcAnswer(toUserId: string, fromUserId: string, answer: any) {
    this.socket.emit('webrtc-answer', { toUserId, fromUserId, answer });
  }

  sendWebrtcIceCandidate(toUserId: string, fromUserId: string, candidate: any) {
    this.socket.emit('webrtc-ice-candidate', { toUserId, fromUserId, candidate });
  }

  onWebrtcOffer(callback: (data: any) => void) {
    this.socket.on('webrtc-offer', callback);
  }

  onWebrtcAnswer(callback: (data: any) => void) {
    this.socket.on('webrtc-answer', callback);
  }

  onWebrtcIceCandidate(callback: (data: any) => void) {
    this.socket.on('webrtc-ice-candidate', callback);
  }
}